import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const TableOfContents = ({ sections }) => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections?.map(section => 
        document.getElementById(section.id)
      ).filter(Boolean);

      if (!sectionElements?.length) return;

      const scrollPosition = window.scrollY + 100;
      
      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const element = sectionElements[i];
        if (element && element.offsetTop <= scrollPosition) {
          setActiveSection(element.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (!sections?.length) return null;

  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-6 sticky top-24">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="List" size={20} className="text-primary" />
        <h3 className="font-heading font-semibold text-lg text-accent-800">
          Table of Contents
        </h3>
      </div>
      
      <nav className="space-y-2">
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => scrollToSection(section.id)}
            className={`w-full text-left px-3 py-2 rounded-lg transition-all duration-200 text-sm ${
              activeSection === section.id
                ? 'bg-primary text-white shadow-md'
                : 'text-accent-600 hover:bg-accent-50 hover:text-accent-800'
            }`}
          >
            {section.title}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TableOfContents;